import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route, NavLink } from "react-router-dom";
import axios from "axios";
import OrdersGraph from "./components/OrdersGraph";
import OrdersList from "./components/OrdersTable";

const consumerKey = "ck_525734b283ba5b2acae997b06583011931eed585";
const consumerSecret = "cs_74fa9d3d256f73a668eef7bf9e31f75c1502e643";
const siteUrl = "https://db.store1920.com/wp-json/wc/v3/orders";

const App = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fetch orders once
  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const response = await axios.get(siteUrl, {
          auth: {
            username: consumerKey,
            password: consumerSecret,
          },
        });
        setOrders(Array.isArray(response.data) ? response.data : []);
      } catch (err) {
        console.error("Error fetching orders:", err);
        setError(err);
      } finally {
        setLoading(false);
      }
    };
    fetchOrders();
  }, []);

  const sidebarStyle = {
    width: "220px",
    background: "#2c3e50",
    color: "white",
    padding: "20px",
    display: "flex",
    flexDirection: "column",
    minHeight: "100vh",
  };

  const navLinkStyle = {
    display: "block",
    color: "#bdc3c7",
    marginBottom: "15px",
    textDecoration: "none",
    fontWeight: "bold",
  };

  const navLinkActiveStyle = {
    color: "#ecf0f1",
  };

  const mainContentStyle = {
    flex: 1,
    padding: "20px",
    background: "#ecf0f1",
  };

  const containerStyle = {
    display: "flex",
    minHeight: "100vh",
    fontFamily: "Arial, sans-serif",
  };

  if (loading) return <p style={{ padding: "20px" }}>Loading orders...</p>;
  if (error) return <p style={{ padding: "20px" }}>Error fetching orders!</p>;

  return (
    <Router>
      <div style={containerStyle}>
        {/* Sidebar */}
        <aside style={sidebarStyle}>
          <h2 style={{ color: "#ecf0f1", marginBottom: "20px" }}>Woo Dashboard</h2>
          <NavLink
            to="/"
            style={navLinkStyle}
            end
            activeStyle={navLinkActiveStyle}
          >
            Dashboard
          </NavLink>
          <NavLink
            to="/orders"
            style={navLinkStyle}
            activeStyle={navLinkActiveStyle}
          >
            Orders
          </NavLink>
        </aside>

        {/* Main Content */}
        <main style={mainContentStyle}>
          <Routes>
            <Route path="/" element={<OrdersGraph orders={orders} />} />
            <Route path="/orders" element={<OrdersList orders={orders} />} />
          </Routes>
        </main>
      </div>
    </Router>
  );
};

export default App;
